/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import * as React from "react";
import { Redirect, Route } from "react-router";
import ErrorPage401 from "components/base/ErrorPage/ErrorPage401";
import ErrorPage404 from "components/base/ErrorPage/ErrorPage404";
import ErrorPage500 from "components/base/ErrorPage/ErrorPage500";
import NetworkErrorPage from "components/base/ErrorPage/NetworkErrorPage";

export default function() {
  return [
    <Route key="ErrorPage401" path="/error/401" component={ErrorPage401} exact />,
    <Route key="ErrorPage500" path="/error/500" component={ErrorPage500} exact />,
    <Route key="NetworkError" path="/error/network-error" component={NetworkErrorPage} exact />,
    <Route key="ErrorPage404" path="/error/404" component={ErrorPage404} exact />,
    <Redirect key="RedirectTo404" to="/error/404" />,
  ];
}
